import angular from 'angular';

import InventoryPacksTabComponent from './inventory-packs-tab-component';

export default angular.module('inventory-packs-tab', []).component('inventoryPacksTab', new InventoryPacksTabComponent());



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/inventory-packs-tab/inventory-packs-tab-module.js